import Vue from "vue";
import VueRouter from "vue-router";
import { currentLocal } from "src/i18n";
import { EventBus } from "src/event-bus.js";
import store from "src/store";

import Facts from "templates/views/Facts";
import Places from "templates/views/Places";
import Economies from "templates/views/Economies";
import Economy from "templates/views/Economy";
import Campaign from "templates/views/Campaign";
import Campaign2024 from "templates/views/Campaign2024";
import Story from "templates/views/Story";
import Sources from "templates/views/Sources";

// Use plugin
Vue.use(VueRouter);

/**
 *
 * Since it may change every year, simply change the variable bellow to control wich page act as the homepage
 * Use the route path without slash
 */
const homepageRedirect = "2024";

const routes = [
    {
        name: "campaign_2024",
        path: "/2024",
        component: Campaign2024,
        meta: {
            prismicHandle: "campaign_2024",
            single: true
        }
    },
    {
        name: "facts",
        path: "/faits",
        component: Facts,
        meta: {
            prismicHandle: "facts",
            single: true
        }
    },
    {
        name: "campaign_2022",
        path: "/nouveau-depart",
        component: Campaign,
        meta: {
            prismicHandle: "campaign_2022",
            single: true
        }
    },
    {
        name: "campaign_2021",
        path: "/donner-du-sens",
        component: Campaign,
        meta: {
            prismicHandle: "campaign_2021",
            single: true
        }
    },
    {
        name: "economies",
        path: "/economies",
        component: Economies,
        meta: {
            prismicHandle: "economies",
            single: true
        }
    },
    {
        name: "economy",
        path: "/economies/:uid",
        component: Economy,
        meta: {
            prismicHandle: "economy"
        }
    },

    {
        name: "story",
        path: "/histoires/:uid",
        component: Story,
        meta: {
            prismicHandle: "story"
        }
    },
    {
        name: "places",
        path: "/partout",
        component: Places,
        meta: {
            prismicHandle: "places",
            single: true
        }
    },
    {
        name: "sources",
        path: "/sources",
        component: Sources,
        meta: {
            prismicHandle: "sources",
            single: true
        }
    },
    {
        name: "stories",
        path: "/histoires",
        redirect: "nouveau-depart"
    },
    {
        path: "/",
        redirect: homepageRedirect
    },
    {
        path: "*",
        redirect: "/"
    }
];

// Create the router with the routes
const router = new VueRouter({
    mode: "history",
    base: currentLocal.lang,
    routes,
    linkActiveClass: "is-current"
});

router.beforeEach((to, from, next) => {
    if (from.name === null) {
        next();
    } else {
        EventBus.$emit("loader-start", next);
    }
});

router.afterEach(to => {
    store.dispatch("global/loadContent", to);
});

// Retrieve story parent path
const storyParentPath = routes.find(r => r.name === "stories").path;

// Export router
export default router;
export { router, routes, storyParentPath };
